import { createSlice } from '@reduxjs/toolkit';
import type { CandidateJobsState } from '../features/dashBoard/types';

const initialState: CandidateJobsState = {
  data: null,
  status: 'idle',
};

export const jobSlice = createSlice({
  name: 'candidatesJob',
  initialState,
  reducers: {
    setCandidatesJobData: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
    },
    clearCandidatesJobData: (state) => {
      state.data = null;
      state.status = 'idle';
    },
  },
});

export const { setCandidatesJobData, clearCandidatesJobData } =
  jobSlice.actions;
export default jobSlice.reducer;
